//import mitt from '@/vendor/mitt/dist/mitt'
import mitt from 'mitt'

export const emitter = mitt()

export default {
  install: (app) => {
    app.config.globalProperties.$emitter = emitter
  }
}
